var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCfx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_1401_15)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9582 9.5301C13.0651 12.338 10.2128 15.1048 7.20001 18.0389C7.20001 16.5954 7.20001 15.3836 7.20001 14.1718C7.22772 13.9826 7.32072 13.8091 7.46276 13.6818C10.2917 10.9414 13.1089 8.23324 15.9816 5.44C16.9392 6.34663 17.8997 7.23272 18.8368 8.13935C20.6527 9.8998 22.4481 11.6896 24.2757 13.4412C24.4556 13.5995 24.5963 13.7979 24.6866 14.0205C24.7768 14.2431 24.814 14.4838 24.7953 14.7234C24.7603 15.765 24.7953 16.8095 24.7953 18.08L15.9582 9.5301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28003 20.0683L16.0046 13.6L17.9088 15.6144L13.6863 20.0509C14.427 20.831 15.2056 21.6549 16.1679 22.6708C17.588 21.029 18.9615 19.4337 20.3379 17.8385L20.7637 18.0102L22.56 20.2721L16.0483 26.56L9.28003 20.0683Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1401_15",
    x1: 2.08,
    y1: 0.799999,
    x2: 30.64,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C4EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13D67A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfx);
export default __webpack_public_path__ + "static/media/cfx.c9f15e78e41adcc2ea1a8ba21de8342d.svg";
export { ForwardRef as ReactComponent };